import { createActor } from 'xstate';
import { appMachine } from './machines/appMachine';
import { getElementOrNull } from './app-dom';
import { isWaveformType } from './app-helpers';
import type { DComposeApp } from './app-core';
export function setupAppActor(app: DComposeApp): void {
  const appActor = createActor(appMachine, {
    input: { initialVolume: -10.5, defaultZoom: (app as unknown as { defaultZoom: number }).defaultZoom, touchDevice: 'ontouchstart' in window },
  });
   appActor.start();
  document.getElementById('midi-settings-toggle')?.addEventListener('click', () => {
    appActor.send({ type: 'MIDI_PANEL_TOGGLE' });
  });
  const _mpeCheckbox = getElementOrNull('mpe-enabled', HTMLInputElement);
  if (_mpeCheckbox) {
    _mpeCheckbox.addEventListener('change', () => {
      appActor.send({ type: 'MPE_ENABLE', enabled: _mpeCheckbox.checked });
    });
  }
  const _mpeSelect = getElementOrNull('mpe-output-select', HTMLSelectElement);
  if (_mpeSelect) {
    _mpeSelect.addEventListener('change', () => {
      appActor.send({ type: 'MPE_SELECT_OUTPUT', outputId: _mpeSelect.value });
    });
  }
  const _waveSelect = getElementOrNull('wave-select', HTMLSelectElement);
  _waveSelect?.addEventListener('change', () => {
    const wf = _waveSelect.value;
    if (isWaveformType(wf)) appActor.send({ type: 'SET_WAVEFORM', waveform: wf });
  });
  const _layoutSelect = getElementOrNull('layout-select', HTMLSelectElement);
  if (_layoutSelect) {
    _layoutSelect.addEventListener('change', () => {
      appActor.send({ type: 'SET_LAYOUT', layoutId: _layoutSelect.value });
    });
  }
  (window as unknown as { dcomposeApp?: unknown }).dcomposeApp = {
    actor: appActor,
    getSnapshot: () => appActor.getSnapshot(),
    getActiveNoteCount: () => (app as unknown as { activeNotes: Map<string, unknown> }).activeNotes.size,
    isAudioReady: () => (app as unknown as { synth: { isInitialized: () => boolean } }).synth.isInitialized(),
    getGridGeometry: () => (app as unknown as { visualizer: { getGridGeometry: () => { cellHv1: {x:number,y:number}, cellHv2: {x:number,y:number}, width: number, height: number } } | null }).visualizer?.getGridGeometry() ?? null,
    getDefaultZoom: () => (app as unknown as { defaultZoom: number }).defaultZoom,
    };
}
